<template>
  <div class="selectGongZhongOption">
    <van-tree-select
      selected-icon=""
      :items="gongZhongList"
      :active-id.sync="gongZhongIds"
      :main-active-index.sync="activeIndex"
      style="height: 100%;"
      @click-nav="onNavClick"
      @click-item="onCityClick"
    />
    <div class="bt_w_125 bt_H_32 gongZhongSubmit">
      <van-button type="default" @click="clearGongZhong">清除</van-button>
      <van-button color="#096CEF" type="primary" @click="gongZhongOnConfirm">确定({{ gongZhongIds.length }}/5)
      </van-button>
    </div>
  </div>
</template>

<script>
import { selectCategoryList, selectByCondition } from '@api/distribution'

export default {
  name: 'selectGongZhongOption',
  props: ['workTypesList'],
  data () {
    return {
      gongZhongIds: [],
      gongZhongList: [],
      activeIndex: 0,
      lsActiveCity: [],
    }
  },
  created () {
    // this.selectCategoryList()
    // 客户端调起关闭弹窗事件
    this.$bridge.registerHandler('closePopup', (data, responseCallback) => {
      this.closePopup()
      responseCallback(data)
    })
  },
  methods: {
    // 获取所有工种分类
    selectCategoryList () {
      selectCategoryList().then(res => {
        if (res.data.code === 200) {
          res.data.data.map(item => {
            this.$set(item, 'text', item.name)
          })
          this.gongZhongList = res.data.data
          let code = this.gongZhongList[this.activeIndex].id
          this.selectGongZhongId(code, this.activeIndex)

          this.initData()
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 点击工种
    onNavClick (index) {
      let code = this.gongZhongList[index].id
      this.selectGongZhongId(code, index)
    },
    // 获取工种分类下面的工种
    selectGongZhongId (code, index) {
      selectByCondition({
        categoryId: code
      }).then(res => {
        if (res.data.code === 200) {
          res.data.data.map(item => {
            this.$set(item, 'text', item.name)
          })
          this.gongZhongList[index].children = res.data.data
          this.$forceUpdate()
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 选择右侧工种选项
    onCityClick (item) {
      if (this.gongZhongIds.indexOf(item.id) > -1) {
        if (this.gongZhongIds.length > 5) {
          this.$toastMsg('最多选择5个工种')
          let index = this.gongZhongIds.indexOf(item.id)
          if (index > -1) {
            this.gongZhongIds.splice(index, 1)
          }
        } else {
          this.lsActiveCity.push(item)
        }
        let id = item.categoryId
        for (let i = 0; i < this.gongZhongList.length; i++) {
          if (id === this.gongZhongList[i].id) {
            this.gongZhongList[i].dot = true
            break
          }
        }
        let isHot = item.isHot
        if (isHot === 1) {
          this.gongZhongList[0].dot = true
        }
      } else {
        let id = item.categoryId
        let hasCity = false
        for (let i = 0; i < this.lsActiveCity.length; i++) {
          if (this.gongZhongIds.indexOf(this.lsActiveCity[i].id) > -1) {
            if (id === this.lsActiveCity[i].categoryId) {
              hasCity = true
              break
            }
          }
        }
        if (!hasCity) {
          let id = item.categoryId
          for (let i = 0; i < this.gongZhongList.length; i++) {
            if (id === this.gongZhongList[i].id) {
              this.gongZhongList[i].dot = false
              break
            }
          }
        }
        let Hot = false
        for (let i = 0; i < this.gongZhongIds.length; i++) {
          for (let j = 0; j < this.lsActiveCity.length; j++) {
            if ((this.gongZhongIds[i] == this.lsActiveCity[j].id) && (this.lsActiveCity[j].isHot == 1)) {
              Hot = true
              break
            }
          }
        }
        this.gongZhongList[0].dot = Hot
        let spliceIndex = this.lsActiveCity.indexOf(item.id)
        this.lsActiveCity.splice(spliceIndex, 1)
      }
    },
    clearGongZhong () {
      this.lsActiveCity = []
      this.gongZhongIds = []
      for (let j = 0; j < this.gongZhongList.length; j++) {
        this.gongZhongList[j].dot = false
      }
    },
    gongZhongOnConfirm () {
      this.$emit('closeGongZhong', this.lsActiveCity)
    },
    closePopup () {
      this.$emit('close')
    },
    initPage () {
      this.$bridge.callHandler('showPopup', response => {
        console.log('response:', response)
      })

      if (this.gongZhongList.length == 0) {
        this.selectCategoryList()
      } else {
        this.initData()
      }
    },

    initData () {
      if (this.workTypesList) {
        this.gongZhongIds = this.workTypesList.map(item => item.id)
        this.lsActiveCity = JSON.parse(JSON.stringify(this.workTypesList))
        for (let j = 0; j < this.gongZhongList.length; j++) {
          this.gongZhongList[j].dot = false
        }
        for (let i = 0; i < this.lsActiveCity.length; i++) {
          let id = this.lsActiveCity[i].categoryId
          for (let j = 0; j < this.gongZhongList.length; j++) {
            if (id == this.gongZhongList[j].id) {
              this.gongZhongList[j].dot = true
            }
          }
        }

        let Hot = false
        for (let i = 0; i < this.gongZhongIds.length; i++) {
          for (let j = 0; j < this.lsActiveCity.length; j++) {
            if ((this.gongZhongIds[i] == this.lsActiveCity[j].id) && (this.lsActiveCity[j].isHot == 1)) {
              Hot = true
              break
            }
          }
        }
        this.gongZhongList[0].dot = Hot
      }
    }
  }
}
</script>

<style lang="scss">
@import "../assets/css/mixin";

.selectGongZhongOption {

  font-size: 20px;

  .van-sidebar-item--select::before {
    background-color: #096CEF;
    height: 100%;
  }

  .van-tree-select__item--active {
    color: #096CEF;
  }

  .van-tree-select {
    @include add_size($font_size_14);
  }

  .van-tree-select__item {
    padding: 10px 6px;
    line-height: 32px !important;
  }

  .van-sidebar-item {
    @include add_size($font_size_14);
  }

  .van-tree-select {
    height: 90vh !important;
  }

  .van-tree-select__nav {
    background: #F7F8FA;
  }

  .gongZhongSubmit {
    width: 100%;
    position: absolute;
    background: #fff;
    bottom: 0;
    height: 60px;
    border-top: 1px solid #f2f3f5;
    padding-top: 4px;

    .van-button {
      border-radius: 33px;
      margin-left: 40px;
    }

    .van-button--default {
      color: #333;
      background-color: #fff;
    }

    .van-button--normal {
      font-size: 15px;
    }
  }

  .van-tree-select__content {
    text-align: center;
  }

  .van-info--dot {
    background-color: #FFB111;
  }

  .van-tree-select__content {
    .van-ellipsis {
      word-wrap: break-word !important;
      overflow: initial;
      white-space: break-spaces;
      word-break: normal;
    }
  }
}
</style>
